import { ValidationSummary } from 'devextreme-react/validation-summary';
import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	CancelChangeOrderButton,
	CancelConfirmationButton,
	ChangeOrderButton,
	ChangeOrderFiles,
	ConfirmButton,
	CreateEstimateButton,
	ExitButton,
	IMEOrderConfirmPopover,
	PlumbingBanner,
	RequestCancellationButton,
	RetailOrderAddNoteButton,
	RetailOrderCommunicationButton,
	RetailOrderDatesPanel,
	RetailOrderFilesButton,
	RetailOrderInformationCards,
	RetailOrderNotesPanel,
	RetailOrderPage,
	RetailOrderProducts,
	RetailOrderProgress,
	RetailOrderProgressStep,
	SetToPendingButton,
	ViewChangeRequestButton
} from '../../../features/cfi/retail-order';
import '../../../css/order.scss';

export default function RetailOrderConfirmPage() {

	return (
		<RetailOrderPage>

			<PlumbingBanner />

			<RetailOrderInformationCards />

			<RetailOrderProgress />

			<ValidationSummary />

			<Box>
				<Item ratio={1}>
					<Toolbar className='button-toolbar' multiline={true} >
						<ToolbarItem>
							<ConfirmButton />
							<CancelConfirmationButton />
							<CancelChangeOrderButton />
						</ToolbarItem>
						<ToolbarItem>
							<ChangeOrderButton step={RetailOrderProgressStep.Confirm} />
						</ToolbarItem>
						<ToolbarItem>
							<ViewChangeRequestButton step={RetailOrderProgressStep.Confirm} />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderCommunicationButton />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderFilesButton />
						</ToolbarItem>
						<ToolbarItem>
							<SetToPendingButton />
						</ToolbarItem>
						<ToolbarItem>
							<CreateEstimateButton />
						</ToolbarItem>
						<ToolbarItem >
							<RequestCancellationButton />
						</ToolbarItem>
						<ToolbarItem>
							<ExitButton />
						</ToolbarItem>
					</Toolbar>
				</Item>
				<Item ratio={0} baseSize={190}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<RetailOrderAddNoteButton showNoteType={false} changeOrder={false} />
						</ToolbarItem>
					</Toolbar>
				</Item>
			</Box>

			<Box>
				<Item ratio={1}>
					<RetailOrderDatesPanel
						showScheduledInstallDates={false}
						showInvoiceDate={false}
						editCabinetDates={false}
						showChangeOrderCallScript={true} />
				</Item>
				<Item ratio={1}>
					<RetailOrderNotesPanel height={200} />
				</Item>
			</Box>

			<ChangeOrderFiles />

			<RetailOrderProducts />

			<IMEOrderConfirmPopover />
		</RetailOrderPage>
	)
}
